import React, { useState, useEffect, useRef } from "react";
import Button from "@dtci/spellbook/Button";
import styles from "./LogMessageCellRenderer.module.scss";

/**
 * Cell renderer that displays log messages in a <pre> tag to preserve formatting.
 * Supports expand/collapse functionality for long content.
 */
const LogMessageCellRenderer = ({ value }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const preRef = useRef(null);

  useEffect(() => {
    if (preRef.current) {
      // Check if content overflows the collapsed height
      const element = preRef.current;
      const isOverflowing = element.scrollHeight > element.clientHeight;
      setHasOverflow(isOverflowing);
    }
  }, [value]);

  if (!value) return null;

  const toggleExpanded = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.logMessageCellRenderer}>
      <pre
        ref={preRef}
        className={isExpanded ? styles.expanded : styles.collapsed}
      >
        {value}
      </pre>
      {hasOverflow && (
        <Button
          className={styles.expandToggle}
          styleType="standard"
          iconType={isExpanded ? "fa-chevron-up" : "fa-chevron-down"}
          onClick={toggleExpanded}
          title={isExpanded ? "Collapse" : "Expand"}
        />
      )}
    </div>
  );
};

export default LogMessageCellRenderer;
